import styled from '@emotion/styled'
import StepHeader, { StepHeaderProps } from './step.header'
import React from 'react'

interface StepRootProps {
  header?: StepHeaderProps
  children: React.ReactNode
}

export default function StepRoot({ header, children }: StepRootProps) {
  return (
    <Root>
      {header && <StepHeader {...header} />}
      <Main>{children}</Main>
    </Root>
  )
}

const Root = styled.div`
  gap: 24px;
  display: flex;
  flex-direction: column;
`

const Main = styled.div`
  gap: 16px;
  display: flex;
  flex-direction: column;
`
